import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { supportState } from '@/utils/student-support-session'

const {mapActions: mapMasterActionsMixin } = createNamespacedHelpers('Master')

Vue.mixin({
  computed: {
    isStudentSupportReadOnly () { return supportState.mode }
  },
  data: function () {
    return {
      foo: 'foo',
      bar: 'bar',
      actionID: '',
      isChoose: [''],
      tableName: '',
      created: false
    }
  },
  methods: {
    ...mapMasterActionsMixin(['updateSetDefaultMaster']),
    convertToThaiBaht (number) { //async (number) => {
      const thaiBahtArr = (number, length) => {
        const txtNumber = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า', 'สิบ'];
        const txtDigit = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];
        let baht = '';

        for (let i = 0; i < length; i += 1) {
          const tmp = number[0].substring(i, i + 1) - 0;

          if (tmp !== 0) {
            if (i === length - 1 && tmp === 1) {
              baht += 'เอ็ด';
            } else if (i === length - 2 && tmp === 2) {
              baht += 'ยี่';
            } else if (i === length - 2 && tmp === 1) {
              baht += '';
            } else {
              baht += txtNumber[tmp];
            }
            baht += txtDigit[length - i - 1];
          }
        }
        return baht;
      }

      number = String(number);
      // ตัดสิ่งที่ไม่ต้องการทิ้งลงโถส้วม
      for (let i = 0; i < number.length; i += 1) {
        number = number.replace(',', ''); // ไม่ต้องการเครื่องหมายคอมมาร์
        number = number.replace(' ', ''); // ไม่ต้องการช่องว่าง
        number = number.replace('บาท', ''); // ไม่ต้องการตัวหนังสือ บาท
        number = number.replace('฿', ''); // ไม่ต้องการสัญลักษณ์สกุลเงินบาท
      }

      let baht = '';
      // ตรวจสอบดูซะหน่อยว่าใช่ตัวเลขที่ถูกต้องหรือเปล่า ด้วย isNaN == true ถ้าเป็นข้อความ == false ถ้าเป็นตัวเลข
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(number)) {
        return 'ข้อมูลนำเข้าไม่ถูกต้อง';
      }
      // ตรวสอบอีกสักครั้งว่าตัวเลขมากเกินความต้องการหรือเปล่า
      if (number - 0 > 9999999.9999) {
        return 'ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้';
      }
      // พรากทศนิยม กับจำนวนเต็มออกจากกัน (บาปหรือเปล่าหนอเรา พรากคู่เขา)
      number = number.split('.');

      // ขั้นตอนต่อไปนี้เป็นการประมวลผลดูกันเอาเองครับ แบบว่าขี้เกียจจะจิ้มดีดแล้ว อิอิอิ
      if (number.length > 1 && number[1].length > 0) {
        number[1] = number[1].substring(0, 2);
      }

      baht = thaiBahtArr(number, number[0].length);
      baht += 'บาท';

      if (number.length === 1 || number[1] === '0' || number[1] === '00') {
        baht += 'ถ้วน';
      } else {
        baht = thaiBahtArr(number, number[1].length);
        baht += 'สตางค์';
      }

      if (baht === 'บาทถ้วน') {
        baht = 'ศูนย์บาทถ้วน';
      }

      return baht;
    },
    setFocusOnInput(type, inputName) {
      const vm = this
      vm.$refs[inputName].$el.querySelector(type).focus();
    },
    getIsChooseColor (status) {
      if (status === true)   return 'success'
      if (status === false) return 'danger'
      return 'primary'
    },
    getStatusColor (status) {
      if (status === 'Enabled')   return 'success'
      if (status === 'Disabled') return 'danger'
      return 'primary'
    }, //"pms" function check permissions "permissions" get name of submenu "service" get ['visible','create','edit','delete'] visible create edit delete "callback" get ["b","r"] return boolean or redirect
    getStatusAction (status) {
      let color = ""
      let txt = ""
      if (status) {
        color = 'success'
        txt = 'ปกติ'
      } else {
        color = 'danger'
        txt = 'ยกเลิก'
      }
      return { color: color, txt: txt }
    },
    pms (permissions, service, callback) {
      const vm = this
      try {
        const result = vm.$store.state.permissions.find( res => {
          return res.subMenuName === permissions && res[service] === true
        })
        if(callback === "b"){
          return (result ? true : false)
        }else if(callback === "r"){
          if(result){
            return true
          }else{
            setTimeout(() => {
              vm.$router.push("/pages/not-authorized")
            }, 200);
          }
        }else{
          return false
        }
      } catch (error) {
        setTimeout(() => {
          this.$router.push("/user/login")
        }, 200);
      }
    },
    // eslint-disable-next-line no-unused-vars
    getAge(){
      return 29
    },

  },
  watch: {
    isChoose: {
      async handler(res, oRes){
        const vm = this
        let id = ""

        if(vm.isChoose.length > 1){
          vm.isChoose.shift()
        }
        if(res !== oRes && oRes[0] !== ''){
          if(vm.isChoose.length >= 1){
            id = vm.isChoose[0]
          }
          vm.updateSetDefaultMaster({
            id,
            form: {tableName: this.tableName},
            vm: null,
            redirect: null
          })
        }
      },
      deep: true
    }
  },
})
